import { Component, computed, effect, ElementRef, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { GeneralNavigationService } from './general-navigation.service';
import { listGroup } from './list-items.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-general-navigation',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        MatIconModule
    ],
    templateUrl: './general-navigation.component.html',
    styleUrl: './general-navigation.component.scss'
})
export class GeneralNavigationComponent {
    public navigationType: 'navigation-rail' | 'navigation-menu' | 'navigation-modal' = 'navigation-menu';
    public isActive: Signal<boolean> = this.service.menuState;
    public theme: '' | 'color-1' = '';

    public items: listGroup[] = [];

    private get element(): HTMLElement {
        return this.el.nativeElement;
    }

    constructor(
        private el: ElementRef<HTMLElement>,
        private service: GeneralNavigationService
    ) {
        effect(() => {
            this.isActive() ? this.activate() : this.deActivate();
        })

        effect(() => {
            let type = this.service.menuType;
            this.setType(type);
        });

        effect(() => {
            let items = this.service.menuItems;
            this.items = items;
        });
    }

    public setType(navigationType: 'navigation-rail' | 'navigation-menu' | 'navigation-modal') {
        this.element.classList.remove(this.navigationType);
        this.navigationType = navigationType;
        this.element.classList.add(this.navigationType);
    }

    /* private setState(isActive: boolean) {
        if (isActive) {
            this.activate();
        } else {
            this.deActivate();
        }
    } */

    public toggleActive() {
        if (this.isActive()) {
            this.close();
        } else {
            this.open();
        }
    }

    public activate() {
        this.element.classList.add('active');
    }

    public deActivate() {
        this.element.classList.remove('active');
    }

    public close() {
        this.service.menuState = false;
        this.deActivate();
    }

    public open() {
        this.service.menuState = true;
        this.activate();
    }
}
